export const LOB = 'holidays';
export const SUB_LOB = 'hol';
export const PAGE_NAMES = {
  LISTING: 'listing',
  DETAILS: 'detail',
  REVIEW: 'review',
  PSM: 'holidays | listing:v1_presales | MMT|null|QUERY',
  PSM_DETAILS: 'detail',
  DIY: 'diy',
  THANK_YOU: 'thankyou',
  SEND_QUERY: 'sendquery',
  LANDING: 'landing',
  EXTERNAL: 'EXTERNAL',
};
export const TEMPLATE_ID = 162275;
export const TOPIC_NAME = 'mmt_holidays_b2c_pdt_client_logging';
export const EVENT_TYPES = {
  USER_ACTION: 'user-action',
  SYSTEM_GENERATED: 'system',
  LIFE_CYCLE: 'life-cycle',
};
export const EVENT_NAMES = {
  BUTTON_CLICK: 'button-clicked',
  VALUE_SELECTED: 'value-selected',
  PRODUCT_VIEWED: 'product-viewed',
  CONTENT_VIEWED: 'content-viewed',
  PAGE_RENDERED: 'page-rendered',
  FILTER_ALL_CLEARED: 'filter_all-cleared',
  FILTER_APPLIED: 'filter-applied',
  CONTENT_CLICKED: 'content-clicked',
  SORT_BY_CLICKED: 'sort_by-clicked',
  NAVIGATION_ICON_CLICKED: 'navigation_icon-clicked',
  SEARCH_CLICKED: 'search-clicked',
  PAGE_EXIT: 'page-exit',
  PAGE_ENTRY: 'page-entry',
  PAGE_RELOAD: 'page-rendered',
  COMPONENTS_SEEN: 'components_seen',
  CHAT_INTERACTED: 'chat-interacted',
  QUERY_SUBMITTED: 'query-submitted',
  TRAVELPLEX_ICON_LOADED: 'new_myra_travel_plex_cta_load',
  CONTENT_SEEN: 'content-seen',
};

export const SUB_PAGE_NAMES = {
  FLIGHTS_DETAILS: 'details:moreFlights',
  HOTEL_DETAILS: 'details:hotelsDetails',
  MORE_HOTELS: 'details:moreHotels',
  TRANSFERS_LISTING: 'details:moreTransferAirport',
  TRANSFERS_DETAILS: 'details:TransferAirport',
  TRANSPORTS_LISTING: 'details:moretransportoptions',
  TRANSPORTS_DETAILS: 'details:detailmoretransportoptions',
  ACTIVITY_DETAILS: 'details:activityDetails',
  ACTIVITY_LISTING: 'details:moreActivities',
  PSM_DETAILS_MODIFY: 'details-V3-presales-modify',
};
export const TRAVELPLEX_CONSTANTS = {
  CHAT_BOT__BRIDGE__GET_META_DATA: 'CHAT_BOT__BRIDGE__GET_META_DATA',
  CHAT_BOT__BRIDGE__TRIGGER_ANALYTICS: 'CHAT_BOT__BRIDGE__TRIGGER_ANALYTICS',
  CHAT_BOT__BRIDGE__OPTIONS_CLICKED: 'CHAT_BOT__BRIDGE__OPTIONS_CLICKED',
  CHAT_BOT__GET_META_DATA: 'CHAT_BOT__GET_META_DATA',
};
